/**
 * Determines the significance of an error.
 * Used by ErrorMessage to differentiate between fatal and non fatal errors.
 */
export enum CustomErrorSignificance {
    NonFatal,
    Fatal,
}
